/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Dropdown, Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import Box from '@material-ui/core/Box';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  mfgNameFieldLabel,
  mfgIdFieldLabel,
  errorTypeNoData,
  errorTypeValidate,
  navigate,
  SUCCESS_MAINTAIN,
} from './ConstantData';
import Contracts from './Contracts';
import ContactDifferences from './ContactDifferences';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getContactDifferencesCms,
  getContactDifferencesMfg,
  getLabelerDifferencesData,
  getSaveLabelerDifferences,
  dispatchErrorMessageData,
  getLabelerDifferencesContract,
  dispatchInputVal,
  dispatchMfgId,
  dispatchSingleLabeler,
  setLabelerDiffTab,
  dispatchCheckedValue,
  dispatchTabValue,
  dispatchGetLabelerDIffrences,
  dispatchGetLabelerDifferencesContract,
  dispatchGetContactDifferencesMfginv,
  dispatchGetContactDifferencesCmsinv,
} from '../store/actions';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  NO_DIFFERENCE_IN_LABELER,
  ERR_PAGINATE_VALUE,
  INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import {
  closeTab,
  redirectURLLink,
  isNumeric,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { getAllCommentCorrListForCommonPoc } from '../../../System/commentsAndCorrespondence/store/Actions';

const LabelerDifferences = () => {
  const defaultCheck = {
    dramContact: false,
    longTermCare: false,
    useCmsContact: false,
  }
  const [singleLabeler, setSingleLabeler] = useState({
    ccCommentsExist: 1,
  });
  const [correctSquare, setCorrectSquare] = useState(null);
  const [labelerDiffList, setLabelerDiffList] = useState([]);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [linkTableName, setLinkTableName] = useState('MFG');
  const [tabValue, setTabValue] = useState();
  const [showComments, setShowComments] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [cancelPopup, setCancelPopup] = useState(false);
  const [inputVal, setInputVal] = useState();
  const [successNote, setSuccessNote] = useState([]);
  const [curIndex, setCurIndex] = useState();
  const [checkValues, setCheckValues] = useState(defaultCheck);
  const [pagenum, setPagenum] = useState();

  const dispatch = useDispatch();
  const editCheckTab = (data) => {
    return dispatch(setLabelerDiffTab(data));
  };
  const history = useHistory();
  // useSelector function
  const getErrorMsg = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.errorMessageInRedux
  );
  const getLabelerDifferences = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.labelerDifferences
  );
  const setInputValue = useSelector((state) => {
    return state.sharedState.LabelerDifferencesReducer.inputValue;
  });
  const getMfgId = useSelector((state) => {
    return state.sharedState.LabelerDifferencesReducer.mfgId;
  });
  const getSingleLabelerData = useSelector((state) => {
    return state.sharedState.LabelerDifferencesReducer.singleLabelerData;
  });
  const contactDifferencesMfg = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contactDifferencesMfg
  );
  const contactDifferencesCms = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contactDifferencesCms
  );
  const getCheckBoxValue = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.checkedValue
  );
  const getTabValue = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.tabValue
  );
  const getContarctDifferences = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contractDifferences
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });

  const contactDiffValues =
    contactDifferencesMfg &&
    contactDifferencesMfg.labelerDifferencesContactResponseVO
      ? contactDifferencesMfg?.labelerDifferencesContactResponseVO
      : [];
  const contactDiffValuesCms =
    contactDifferencesCms &&
    contactDifferencesCms.labelerDifferencesContactResponseVO
      ? contactDifferencesCms?.labelerDifferencesContactResponseVO
      : [];

  const labelerDiffTabData = useSelector((state) => {
    return state.sharedState.LabelerDifferencesReducer.labelerDiffTabObj;
  });

  // setCheckValue from redux
  React.useEffect(() => {
    setCheckValues(defaultCheck)
    let newVal = []
    const checkExtra = {
      dramContact: false,
      longTermCare: false,
      useCmsContact: false,
      contactSeqNum: correctSquare
    }
    if (!_.isEmpty(getCheckBoxValue) && !_.isEmpty(getSingleLabelerData)) {
      newVal = _.filter(getCheckBoxValue, l => l.id === getSingleLabelerData.id)
    }
    setCheckValues(!_.isEmpty(newVal) ? newVal[0] : checkExtra);
  }, [getCheckBoxValue, curIndex]);

  // setTabValue from Redux
  React.useEffect(() => {
    setTabValue(getTabValue);
  }, [getTabValue]);

  // save api payload for respective checkValues
  React.useEffect(() => {
    if (!_.isEmpty(getCheckBoxValue) && !_.isEmpty(getSingleLabelerData)) {
      const newVal = _.filter(getCheckBoxValue, l => l.id === getSingleLabelerData.id)
      if (!_.isEmpty(newVal)) {
        if (newVal[0].dramContact) {
          setCorrectSquare(
            contactDiffValues.length > 0 ? contactDiffValues[0]?.contactSeqNum : ''
          );
        }
        if (newVal[0].useCmsContact) {
          setCorrectSquare(
            contactDiffValuesCms.length > 0
              ? contactDiffValuesCms[0]?.contactSeqNum
              : ''
          );
        }
      }
    }
  }, [getCheckBoxValue]);

  //  master save functionality
  const masterDataSave = async (data) => {
    if (!_.isEmpty(getCheckBoxValue)) {
      const filterPayload = _.filter(getCheckBoxValue, l => l.contactSeqNum && l.contactSeqNum !== null && l.contactSeqNum !== '')
      if (!_.isEmpty(filterPayload)) {
        const payload = _.map(filterPayload, (v, i) => ({
          dramContact: v.dramContact,
          cmsContact: v.useCmsContact,
          deleteDramContact: v.longTermCare,
          contactSeqNum: v.contactSeqNum,
        }))
        // const payload = {
        //   dramContact: checkValues.dramContact,
        //   cmsContact: checkValues.useCmsContact,
        //   deleteDramContact: checkValues.longTermCare,
        //   contactSeqNum: correctSquare,
        // }
        setCheckValues(defaultCheck)
        handleSaveClose();
        const result = await dispatch(getSaveLabelerDifferences(payload));
        dispatch(dispatchGetLabelerDifferencesContract([]));
        dispatch(dispatchGetContactDifferencesMfginv([]));
        dispatch(dispatchGetContactDifferencesCmsinv([]));
        dispatch(dispatchSingleLabeler({}));
        dispatch(dispatchMfgId(''));

        if (result?.payload?.labelerDifferencesSaveResponse?.status == 'Success') {
          setSuccessNote([SUCCESS_MAINTAIN]);
          if (data == 'fromlocalSD') {
            dispatch(setLabelerDiffTab({}));
            dispatch(dispatchGetLabelerDIffrences([]));
            dispatch(dispatchErrorMessageData([]));
            dispatch(dispatchGetLabelerDifferencesContract([]));
            dispatch(dispatchGetContactDifferencesMfginv([]));
            dispatch(dispatchGetContactDifferencesCmsinv([]));
            dispatch(dispatchSingleLabeler({}));
            dispatch(dispatchMfgId(''));
            dispatch(dispatchTabValue('one'));
            dispatch(
              dispatchCheckedValue([])
            );
            dispatch(dispatchInputVal(1));
            closeTab(navigate, history);
          } else {
            dispatch(getLabelerDifferencesData({}));
          }
        } else {
          dispatch(dispatchErrorMessageData(['The request failed.']));
        }
      }
    }
  };

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === navigate && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === navigate && item.isFormSave) {
          item.isFormSave = false;
          masterDataSave('fromlocalSD');
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    let disabledSaveCancelBtn1 = checkValues.dramContact
      ? false
      : checkValues.useCmsContact
      ? false
      : true;

    if (labelerDiffTabData && Object.keys(labelerDiffTabData).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === navigate && !disabledSaveCancelBtn1) {
            item.isFormDirty = true;
            if (
              labelerDiffTabData.errorMessages &&
              labelerDiffTabData.errorMessages.length > 0
            ) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          } else {
            if (item.navTo === navigate);
            item.isFormDirty = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [labelerDiffTabData, checkValues]);

  // save and cancle button disabled functionality
  React.useEffect(() => {
    let disabledSaveCancelBtn1 = checkValues.dramContact
      ? false
      : checkValues.useCmsContact
      ? false
      : true;
    editCheckTab({
      ...labelerDiffTabData,
      disabledSaveCancelBtn: disabledSaveCancelBtn1,
    });
  }, [checkValues]);

  // setting setInputValue value from redux into local state
  React.useEffect(() => {
    setCurIndex(setInputValue);
  }, [setInputValue]);

  // comment icon functionality
  React.useEffect(() => {
    if (getSingleLabelerData && Object.keys(getSingleLabelerData).length > 0) {
      // eslint-disable-next-line prefer-const
      let temp = getSingleLabelerData;
      temp.ccCommentsExist = 0;
      setSingleLabeler(temp);
    }
  }, [getSingleLabelerData]);

  React.useEffect(()=>{
    if(getSingleLabelerData && typeof getSingleLabelerData==="object" && 'corrLinkId' in getSingleLabelerData ){
    fetchCommentList(getSingleLabelerData);
    }
    
  },[getSingleLabelerData])

  const fetchCommentList = async (data) => {
    dispatch(getAllCommentCorrListForCommonPoc(null));
    if (linkTableName === 'MFG') {
      let Obj = data;
      const result = await dispatch(
        getAllCommentCorrListForCommonPoc({
          corrLinkId: data.corrLinkId,
          linkTableName: 'MFG',
        })
      );
      if (result && result.CommentListData.length > 0) {
        Obj.ccCommentsExist = 1;
      } else {
        Obj.ccCommentsExist = 0;
      }
      setSingleLabeler(Obj);
    }
  };

  React.useEffect(() => {
    if (linkTableName === 'MFG' && showComments) {
      let newObj = singleLabeler;
      if (commentsList && commentsList.length > 0) {
        newObj.ccCommentsExist = 1;
      } else {
        newObj.ccCommentsExist = 0;
      }
      setSingleLabeler(newObj);
    }
  }, [commentsList]);

  // no button onSave popup functionality
  const handleSaveClose = (a) => {
    setOpen(false);
    // dispatch(dispatchInputVal(pagenum));
    dispatch(dispatchInputVal(pagenum ?? setInputValue ?? 1));
  };

  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  // after save clear all field functionality
  const resetAllFields = () => {
    handelCancelClose();
    setOpen(false);
    setCheckValues(defaultCheck)
    dispatch(
      dispatchCheckedValue([])
    );
  };

  //  set labelerDifference api data functionality
  React.useEffect(() => {
    let list = [];
    let arr = getErrorMsg ? getErrorMsg : [];
    if (
      getLabelerDifferences &&
      getLabelerDifferences.status === STATUS_MSG &&
      getLabelerDifferences.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getLabelerDifferences.labelerDifferencesResponseVO)) {
        list = _.map(
          getLabelerDifferences.labelerDifferencesResponseVO,
          (val, ind) => ({
            ...val,

            indexPaginate: ind + 1,
            id: val.mfgId,
            name: val.mfgName,
          })
        );
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'apiResponse',
              errorType: errorTypeNoData,
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
      } else {
        arr = arr.filter((item) => item.errorType != errorTypeNoData);
        arr.push({
          field: 'apiResponse',
          errorType: errorTypeNoData,
          message: NO_DIFFERENCE_IN_LABELER,
        });
        setSingleLabeler({});
        dispatch(dispatchGetLabelerDifferencesContract([]));
        dispatch(dispatchGetContactDifferencesMfginv([]));
        dispatch(dispatchGetContactDifferencesCmsinv([]));
        dispatch(dispatchMfgId(null));
      }
      const unique = [...new Set(arr)];
      dispatch(dispatchErrorMessageData(unique));
    }
    setLabelerDiffList(list);
    if (_.isEmpty(getSingleLabelerData) && !getMfgId) {
      dispatch(dispatchInputVal(setInputValue));
      dispatch(dispatchSingleLabeler(list[setInputValue - 1]));
      dispatch(dispatchMfgId(list[setInputValue - 1]?.id));
    }
    if (!_.isEmpty(getLabelerDifferences?.labelerDifferencesResponseVO)) {
      if (
        getLabelerDifferences?.labelerDifferencesResponseVO?.length <=
        setInputValue
      ) {
        dispatch(
          dispatchInputVal(
            getLabelerDifferences?.labelerDifferencesResponseVO?.length
          )
        );
        dispatch(
          dispatchSingleLabeler(
            list[
              getLabelerDifferences?.labelerDifferencesResponseVO?.length - 1
            ]
          )
        );
        dispatch(
          dispatchMfgId(
            list[
              getLabelerDifferences?.labelerDifferencesResponseVO?.length - 1
            ]?.id
          )
        );
      }
    }
  }, [getLabelerDifferences]);

  // fetch getLabelarDifferencesData from redux
  React.useEffect(() => {
    if (_.isEmpty(getSingleLabelerData)) {
      dispatch(getLabelerDifferencesData({}));
    }
  }, []);

  // setting spinner
  React.useEffect(() => {
    setLoading(false);
  }, [contactDifferencesMfg, contactDifferencesCms, getContarctDifferences]);

  // fetching contactDifferencesMfg Api and contactDifferencesCms Api
  React.useEffect(() => {
    if (singleLabeler?.id && _.isEmpty(contactDifferencesMfg)) {
      dispatch(
        getContactDifferencesMfg({
          mfgId: [singleLabeler?.id],
        })
      );
      dispatch(
        getContactDifferencesCms({
          mfgId: [singleLabeler?.id],
        })
      );
    }
  }, [singleLabeler]);

  // fetching getLabelerDIfferencesContarct Api
  React.useEffect(() => {
    if (singleLabeler?.id && _.isEmpty(getContarctDifferences)) {
      dispatch(
        getLabelerDifferencesContract({
          mfgId: [singleLabeler?.id],
        })
      );
    }
  }, [singleLabeler]);

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // on change functionality on field of pagination
  const paginateLabelerDiffData = (index, aType) => {
    dispatch(dispatchInputVal(index));
  };

  // on Blur on pagination field
  const onBlurOnTextField = (index, aType) => {
    let arr = getErrorMsg ? (getErrorMsg.length > 0 ? getErrorMsg : []) : [];
    let isPass = false;
    const indexPaginate = parseInt(index);

    if (aType === 'onPopup') {
      isPass = true;
    } else {
      if (
        (!checkValues.dramContact && !checkValues.useCmsContact) ||
        aType === 'input'
      ) {
        let inputValue = isNumeric(index);
        let isInputValue = false;
        if (inputValue && index > labelerDiffList.length) {
          arr = arr.filter((item) => item.errorType != 'inputIsGreter');
          arr.push({
            field: 'input',
            errorType: 'inputIsGreter',
            message: INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
          });
        } else {
          isInputValue = true;
          const indexOf = !_.isEmpty(arr)
            ? _.findIndex(arr, {
                field: 'input',
                errorType: 'inputIsGreter',
              })
            : null;
          if (!_.isNull(indexOf) && indexOf >= 0) {
            arr.splice(indexOf, 1);
          }
        }
        if (inputValue && isInputValue && index !== '0') {
          arr = arr.filter((item) => item.errorType != errorTypeValidate);
          isPass = true;
          const indexOf = !_.isEmpty(arr)
            ? _.findIndex(arr, {
                field: 'input',
                errorType: errorTypeValidate,
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            arr.splice(indexOf, 1);
          }
        } else {
          isPass = false;
          arr = arr.filter((item) => item.errorType != errorTypeValidate);
          if (inputValue && index < labelerDiffList.length) {
            arr.push({
              field: 'input',
              errorType: errorTypeValidate,
              message: ERR_PAGINATE_VALUE,
            });
          }
          if (inputValue === false) {
            arr.push({
              field: 'input',
              errorType: errorTypeValidate,
              message: ERR_PAGINATE_VALUE,
            });
          }
        }
      } else {
        isPass = true
        // setInputVal(indexPaginate);
        // popupOnArrowOnCancel();
        // setPagenum(indexPaginate);
        // return;
      }
    }
    if (
      isPass &&
      !_.isEmpty(labelerDiffList) &&
      indexPaginate != '' &&
      !_.isNull(indexPaginate)
    ) {
      setCheckValues(defaultCheck)
      if (aType === 'input') {
        dispatch(dispatchSingleLabeler(labelerDiffList[indexPaginate - 1]));
      }
      const list = _.filter(
        labelerDiffList,
        (l) => l.indexPaginate === indexPaginate
      );
      if (!_.isEmpty(list)) {
        dispatch(dispatchInputVal(indexPaginate));
        setCurIndex(index);
        setPagenum(index);
        setLoading(true);
        dispatch(dispatchSingleLabeler(list[0]));

        dispatch(dispatchInputVal(list[0]?.indexPaginate));
        dispatch(dispatchMfgId(list[0]?.id));
        dispatch(
          getContactDifferencesMfg({
            mfgId: [list[0]?.id],
          })
        );
        dispatch(
          getContactDifferencesCms({
            mfgId: [list[0]?.id],
          })
        );
        dispatch(
          getLabelerDifferencesContract({
            mfgId: [list[0]?.id],
          })
        );
      }
    }

    // setCurIndex(index);
    const unique = [...new Set(arr)];
    dispatch(dispatchErrorMessageData(unique));
  };

  // dispatch tab value into redux on tabChange
  const handleChange = () => {
    dispatch(dispatchTabValue('two'));
  };

  const handleTabChange = () => {
    dispatch(dispatchTabValue('one'));
    if (fullScreenView) {
      setFullScreenView(!fullScreenView);
    }
  };

  const handleChangeTabValue = () => {};

  const getCommentsService = () => {
    setShowComments(true);
  };

  // go to perticular manufacturer action button handler function
  const handleAction = async () => {
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    let tempObj = singleLabeler;
    tempObj.updateManufacturer = true;
    let result = await dispatch(setSelectManufacturerData(tempObj));
    if (result && Object.keys(result).length > 0) {
      redirectURLLink(
        '/manufacturer-detail',
        'Maintain Manufacturer',
        history,
        dispatch
      );
    }
  };

  //  save popup on yes
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
      resetAllFields();
    } else {
      setOpen(value);
    }
  };

  // cancle button popup on click
  const openCancelPopUp = (value) => {
    if (!value) {
      resetAllFields();
    } else {
      setOpenCancel(value);
    }
  };

  // cancle popup on pagination arrow (onConform)
  const popupOnArrowonConform = () => {
    masterDataSave();
    onBlurOnTextField(inputVal, 'onPopup');
    dispatch(
      dispatchCheckedValue({
        dramContact: false,
        longTermCare: false,
        useCmsContact: false,
      })
    );
    setCancelPopup(!cancelPopup);
  };

  // cancle popup on pagination arrow (No)
  const popupOnArrowOnCancel = () => {
    setCancelPopup(!cancelPopup);
  };

  // Tab highlighter functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigate, true);
    } else {
      tabHighLigther(navigate, false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  return (
    <div
      className="tBillPanel custom-check"
      data-testid="labeler-differences-component"
      onClick={() => {
        if (successNote.length > 0) {
          setSuccessNote([]);
        }
      }}
    >
      <div className="tabs-container">
        <Spinner load={loading} />
        {!fullScreenView && (
          <CustomSeparator parent1="Research" parent2="Labeler Differences" />
        )}
        {getErrorMsg?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            }
          />
        ) : null}
        <DisplaySuccessMessages successMessages={successNote} />
        {!fullScreenView && (
          <Box className="alone-pagination ">
            <Box>
              {singleLabeler?.indexPaginate > 1 ? (
                <Button
                  title="Previous"
                  className="btns rotate-left"
                  data-testid="uc-paginate-arrow-left"
                  disabled={
                    !(setInputValue > 1) ||
                    !isNumeric(setInputValue) ||
                    setInputValue > labelerDiffList.length
                  }
                  onClick={() =>
                    onBlurOnTextField(singleLabeler?.indexPaginate - 1, 'arrow')
                  }
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Previous</span>
                </Button>
              ) : (
                <Button title="Previous" className="btns rotate-left" disabled>
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm" aria-hidden="true">
                    Previous-Btn
                  </span>
                </Button>
              )}
            </Box>
            <Box>
              <label className="m-0" htmlFor="paginate-count">
                <TextField
                  id="paginate-count"
                  data-testid="uc-input-paginate"
                  variant="outlined"
                  className="searchInput input-count"
                  value={labelerDiffList.length > 0 ? curIndex : ''}
                  onChange={(e) => {
                    paginateLabelerDiffData(e.target.value, 'input');
                  }}
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onBlur={(e) => {
                    // if (checkValues.dramContact) {
                    //   openSave(true);
                    // } else {
                    //   if (checkValues.useCmsContact) {
                    //     openSave(true);
                    //   } else {
                        onBlurOnTextField(e.target.value, 'input');
                    //   }
                    // }
                  }}
                />
              </label>
            </Box>
            <Box className="btns"> of {labelerDiffList.length}</Box>
            <Box>
              {singleLabeler &&
              singleLabeler?.indexPaginate < labelerDiffList.length ? (
                <Button
                  id="nextbuttonwitharrow"
                  title="Next"
                  className="btns rotate-right ml-0"
                  data-testid="uc-paginate-arrow-right"
                  disabled={
                    !(setInputValue < labelerDiffList.length) ||
                    !isNumeric(setInputValue)
                  }
                  onClick={() =>
                    onBlurOnTextField(singleLabeler?.indexPaginate + 1, 'arrow')
                  }
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm" aria-hidden="true">
                    Next-Btn
                  </span>
                </Button>
              ) : (
                <Button
                  title="Next"
                  className="btns rotate-right ml-0"
                  disabled
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Next</span>
                </Button>
              )}
            </Box>
          </Box>
        )}
        {!fullScreenView && (
          <div className="row mb-2">
            <div className="col-12">
              <fieldset className="custom-fieldset">
                <legend aria-hidden="true" className="d-none"></legend>
                <div className="row">
                  <div className="col-10 frr-lbl-diff-search">
                    <div className="form-wrapper">
                      <div className="mui-custom-form input-md">
                        {singleLabeler?.name &&
                        singleLabeler?.name !== '' &&
                        singleLabeler?.name.length > 25 ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">
                                {singleLabeler?.name}
                              </Tooltip>
                            }
                          >
                            <TextField
                              data-testid="manufacturer-name-textField"
                              id="manufacturer-name-Labeler-Differences-tooltipCase"
                              required={true}
                              className
                              disabled
                              label={mfgNameFieldLabel}
                              fullWidth
                              placeholder=""
                              inputProps={{ maxLength: 6 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={
                                singleLabeler && singleLabeler.name
                                  ? singleLabeler.name.substring(0, 25) + '...'
                                  : ''
                              }
                            />
                          </OverlayTrigger>
                        ) : (
                          <TextField
                            data-testid="manufacturer-name-textField"
                            id="manufacturer-name-Labeler-Differences"
                            required={true}
                            className
                            disabled
                            label={mfgNameFieldLabel}
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 6 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={
                              singleLabeler && singleLabeler.name
                                ? singleLabeler.name
                                : ''
                            }
                          />
                        )}
                      </div>
                      <div className="mui-custom-form input-md with-select">
                        <TextField
                          data-testid="manufacturer-id-textField"
                          id="manufacturer-id-Labeler-Differences"
                          required={true}
                          className
                          disabled
                          label={mfgIdFieldLabel}
                          fullWidth
                          placeholder=""
                          inputProps={{ maxLength: 6 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            singleLabeler && singleLabeler.id
                              ? singleLabeler.id
                              : ''
                          }
                        />
                      </div>
                      <div className="mui-custom-form input-md">
                        <div className="comment-sec frr-mt-26">
                          Comments &nbsp;
                          {singleLabeler?.corrLinkId !== null &&
                          singleLabeler.ccCommentsExist &&
                          parseInt(singleLabeler.ccCommentsExist) === 1 ? (
                            <img
                              role="button"
                              data-testid="commments_and_correspo_index_icon1"
                              onClick={() => {
                                getCommentsService();
                                setLinkTableName('MFG');
                                setCorrLinkId(singleLabeler?.corrLinkId);
                              }}
                              alt="comment"
                              src={CommentVisibleIcon}
                            />
                          ) : (
                            <img
                              role="button"
                              data-testid="commments_and_correspo_index_icon"
                              onClick={() => {
                                if (singleLabeler?.corrLinkId) {
                                  getCommentsService();
                                  setLinkTableName('MFG');
                                  setCorrLinkId(singleLabeler?.corrLinkId);
                                }
                              }}
                              alt="comment"
                              src={CommentIcon}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
                    >
                      <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
                        <Dropdown.Toggle
                          className="icon-dropdown"
                          aria-label="Go to manufacturer"
                        >
                          <SVGComponent iconName="Icon-export" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            role="button"
                            data-testid="Go_to_manufacturer_action_button"
                            onClick={() => {
                              handleAction();
                            }}
                          >
                            Go To Manufacturer
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
        {!fullScreenView && (
          <div className="row mt-4 mb-3">
            <div className="col-12">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  data-testid="open_Save"
                  onClick={() => {
                    openSave(true);
                  }}
                  disabled={_.isEmpty(getCheckBoxValue)}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  data-testid="open_Cancel"
                  onClick={() => {
                    openCancelPopUp(true);
                  }}
                  disabled={_.isEmpty(getCheckBoxValue)}
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className="frr-tabs-wrapper">
          <AppBar
            position="static"
            sx={{ width: '100%' }}
            style={{ borderBottom: '1px solid #c9c8c5' }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChangeTabValue}
              data-testid="index_tab"
              color="red"
              style={{ color: 'red' }}
            >
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="one"
                label="Contact Differences"
                data-testid="contact_differences_tab"
                onClick={handleTabChange}
                tabIndex={0}
              />

              <Tab
                style={{ textTransform: 'capitalize' }}
                value="two"
                label="Contracts"
                data-testid="contracts_tab"
                onClick={handleChange}
                tabIndex={0}
              />
            </Tabs>
          </AppBar>
        </div>
        <div className="tabs-body">
          {tabValue === 'one' && (
            <ContactDifferences
              checkValues={checkValues}
              singleLabeler={singleLabeler}
              getCheckBoxValue={getCheckBoxValue}
            />
          )}
          {tabValue === 'two' && (
            <Contracts
              data-testid="contractTab"
              fullScreenView={fullScreenView}
              handleFullScreenView={handleFullScreenView}
            />
          )}
        </div>

        <SaveCancelPopup
          data-testid="SavePopup"
          open={open}
          title={'Save'}
          onConfim={() => {
            masterDataSave();
            resetAllFields();
          }}
          onCancel={() => {
            handleSaveClose();
          }}
        />
        <SaveCancelPopup
          data-testid="cancelPopup"
          open={openCancel}
          title={'Cancel'}
          onConfim={() => {
            resetAllFields();
          }}
          onCancel={() => {
            handelCancelClose();
          }}
        />
        <SaveCancelPopup
          data-testid="cancelPopupOnArrow"
          open={cancelPopup}
          title={'Cancel'}
          onConfim={() => {
            popupOnArrowonConform();
          }}
          onCancel={() => {
            popupOnArrowOnCancel();
          }}
        />
        {showComments ? (
          <CommentAndCorrespondenceComponent
            setShowComments={setShowComments}
            linkTableName={'MFG'}
            corrLinkId={corrLinkId}
          />
        ) : null}
      </div>
    </div>
  );
};

export default LabelerDifferences;
